module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/5-0b74f2a451a46bf6f1b0ff7c4ab0b578.png";